import request from '@/utils/request'
import request_py from '@/utils/request_py'
import request_pyV2 from '@/utils/request_py_v2'

export function loginByUsername(username, password,validate_code) {
  const data = {
    username,
    password,
    validate_code
  }
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function getUserInfo(token) {
  return request_py({
    url: '/sys_user/info',
    method: 'get'
  })
}

export function getValidateCode (token) {
  return process.env.BASE_API +  '/validateCode?'+ new Date().getTime()
  // return request({
  //   url: '/validateCode?'+ new Date().getTime(),
  //   method: 'get'
  // })
}

export function getQrCode() {
  return request_py({
    url: '/login_by_qrcode/wx9991bce243907c50/qrcode',
    method: 'get'
  })
}

export function getIsLoginOK(params) {
  return request_py({
    url: '/login_by_qrcode/verify_code',
    method: 'get',
    params
  })
}

export function qrLoginPc(data) {
  return request({
    url: '/user/login/pc/wx_qrcode',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/login.js